import styled from '@emotion/styled';
import { Label, rem } from '@triumph/design-system';

// Mirrors the design system AddNewNote's Wrapper/ButtonsWrapper so the custom
// form (rendered as a sibling above Stepper) visually aligns with the timeline.
export const Wrapper = styled.div`
    display: flex;
    gap: ${rem(12)};
    flex-direction: column;
`;

export const FieldLabel = styled(Label)`
    text-transform: none;
    margin: 0;
    font-size: ${rem(14)};
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    justify-content: end;
    gap: ${rem(8)};
`;

export const ErrorText = styled.div`
    color: #dc2626;
    font-size: 12px;
`;
